import { BADGE_VARIANTS } from 'components/Badge'
import { type StatusBadgeMapper } from './types'

export const TRADE_LICENSE_STATUS_BADGE_VALUES: StatusBadgeMapper = {
  true: {
    variant: BADGE_VARIANTS.GREEN,
    text: 'Active',
  },
  false: {
    variant: BADGE_VARIANTS.RED,
    text: 'Inactive',
  },
} as const
